module.exports = __webpack_public_path__ + "files/a036a27e700361551d74c461d0b8109b.png";